import styled from "styled-components";

export const Container = styled.div`
  width: 80%;
  margin-top: 4em;
  margin-left: auto;
  margin-right: auto;
`;

export const Card = styled.div`
  background: url(${props => props.backgroundImage}) center/cover no-repeat;
  width: 80%;
  display: flex;
  height: 500px;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 30px;

  text-align: center;

  img{
    width: 70px;
  }

`;

export const CardImage = styled.div`
  background: url(${props => props.backgroundImage}) center/cover no-repeat;
  width: 90%;
  display: flex;
  height: 300px;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 30px;

  text-align: center;`

export const Image = styled.div`
  width: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 4em;
`;



export const Title = styled.h3`
  margin-top: 1em;
  font-size: 18px;
  color: white;
`;

export const Description = styled.p`
  font-size: 14px;
  color: white;
  font-style: italic;
`;

export const Button = styled.button`
  background-color: transparent;
  color: rgb(255, 255, 255);
  border: 1px solid rgb(255, 255, 255);
  padding: 5px 40px;
  border-radius: 30px;
  font-size: 0.9em;
  cursor: pointer;
  margin-top: 2.5em;

  a{
    color: white;
    text-decoration: none;
  }

  &:hover {
    background-color: rgba(234, 11, 42, 1);
    border: 1px solid rgba(234, 11, 42, 1);
    color: white;
  }
`;

export const SliderTitle = styled.h2`

`
